import { render, staticRenderFns } from "./ProductsDetailsProvider.vue?vue&type=template&id=17db04c6&"
import script from "./ProductsDetailsProvider.vue?vue&type=script&lang=ts&"
export * from "./ProductsDetailsProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports